import { IconButton, Stack } from '@fluentui/react';
import React, { useContext } from 'react';
import { Deployment, DeploymentMetadataItem } from '../../../models/Deployment';
import { ThemeContext } from '../../../../HubLayout/models/ThemeContext';
import { getThemeFromString } from '../../../../Common/util/localStorageUtils';
import { useIsMobile } from '../../../../Common/hooks/useIsMobile';

interface IDeploymentMetadataProps {
    item: Deployment;
}

export const DeploymentMetadata: React.FC<IDeploymentMetadataProps> = (
    props: IDeploymentMetadataProps
) => {
    const themeContext = useContext(ThemeContext);
    const theme = getThemeFromString(themeContext.themeName);
    const isMobile = useIsMobile();

    const metadataFieldNameStyles: React.CSSProperties = {
        flex: '0 0 140px',
        minWidth: 0,
        paddingRight: '5px',
        boxSizing: 'border-box',
    };

    const metadataValueStyles: React.CSSProperties = {
        display: 'flex',
        flex: '1 1 0',
        minWidth: 0,
        border: '1px gray solid',
        paddingLeft: '5px',
        alignItems: 'center',
        justifyContent: 'space-between',
        overflow: 'hidden',
        boxSizing: 'border-box',
    };

    const desktopMetadataValueStyles: React.CSSProperties = {
        whiteSpace: 'normal',
        wordBreak: 'break-all',
    };

    const metadataContainerStyles: React.CSSProperties = {
        display: 'flex',
        width: '100%',
        minWidth: 0,
        boxSizing: 'border-box',
        paddingLeft: '16px',
        paddingBottom: '5px',
        paddingTop: '10px',
        alignItems: 'center',
    };

    const mobileMetadataContainerStyles: React.CSSProperties = {
        padding: '6px 0px',
    };

    const mobileMetadataValueStyles: React.CSSProperties = {
        whiteSpace: 'normal',
        wordBreak: 'break-all',
        display: 'inline-block',
    };

    const mobileMetadataValueContainerStyles: React.CSSProperties = {
        display: 'flex',
        alignItems: 'center',
        width: '100%',
        overflow: 'hidden',
        border: '1px gray solid',
        justifyContent: 'space-between',
        margin: '6px 0px',
        padding: '6px',
    };

    const copyToClipboard = (metadata: DeploymentMetadataItem) => {
        navigator.clipboard.writeText(metadata.value);
    };

    return props.item.showMetadata ? (
        <div
            style={
                isMobile
                    ? {}
                    : {
                          backgroundColor: theme.palette.neutralLighter,
                          width: '100%',
                          maxWidth: '100%',
                          overflow: 'hidden',
                          boxSizing: 'border-box',
                          paddingLeft: '40px',
                      }
            }
        >
            {Array.from(props.item.deploymentMetadataItems.values()).map(
                (metadata) => {
                    return metadata?.value?.length > 0 ? (
                        <div
                            key={metadata.fieldName}
                            style={
                                isMobile
                                    ? mobileMetadataContainerStyles
                                    : metadataContainerStyles
                            }
                        >
                            <strong style={metadataFieldNameStyles}>
                                {metadata.fieldName}
                            </strong>
                            <div
                                style={
                                    isMobile
                                        ? mobileMetadataValueContainerStyles
                                        : metadataValueStyles
                                }
                            >
                                <div
                                    style={
                                        isMobile
                                            ? mobileMetadataValueStyles
                                            : desktopMetadataValueStyles
                                    }
                                >
                                    {metadata.value}
                                </div>
                                <IconButton
                                    iconProps={{ iconName: 'Copy' }}
                                    onClick={() => copyToClipboard(metadata)}
                                    title={'Copy to clipboard'}
                                    ariaLabel={`Copy ${
                                        metadata?.fieldName ?? 'value'
                                    } to clipboard`}
                                />
                            </div>
                        </div>
                    ) : (
                        <div key={metadata?.fieldName}></div>
                    );
                }
            )}
        </div>
    ) : (
        <div></div>
    );
};
